<div class="color-bar"></div>
<ng-container *ngIf="!idOs">
  <div class="conteudo">
    <div class="container-fluid cartoes" style="background-color: #fff;">
      <div class="row faixa-conteudo pt0">
        <div class="col col-lg-12">
          <div class="caixa">
            <div class="conteudo-caixa-sem-titulo sem-padding">
              <div class="row ptb50 align-items-end" [formGroup]="form">
                <div class="col col-3">
                  <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                    {{'relatorioVeiculos.controleProposta.dataInicial'}}
                  </div>
                  <p-calendar formControlName="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                    icon="pi pi-calendar" styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}"
                    [yearNavigator]="true" (onClearClick)="limpaDataInicial()" (onSelect)="onSelectDataInicial($event)"
                    [monthNavigator]="true" yearRange="2000:2030"
                    placeholder="{{'vorPCA.dataInicialPlaceHolder' | translate}}" showButtonBar="true">
                  </p-calendar>
                </div>
                <div class="col col-3">
                  <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                    {{'relatorioVeiculos.controleProposta.dataFinal'}}
                  </div>
                  <p-calendar formControlName="data_final" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                    styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                    (onSelect)="onSelectDataFinal($event)" placeholder="{{'vorPCA.dataFinalPlaceHolder' | translate}}"
                    showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                  </p-calendar>
                </div>
                <div class="col col-2">
                  <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                    {{'relatorioVeiculos.controleProposta.tipo_data'}}
                  </div>
                  <p-dropdown appendTo="body"
                    placeholder="{{'relatorioVeiculos.controleProposta.tipo_dataPlaceHolder' | translate }}"
                    [options]="tipoDataOptions" optionLabel="name" optionValue="value" (onChange)="capturarValor($event.value)"
                    [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
                  </p-dropdown>
                </div>
                <div class="col col-4 d-flex align-items-end justify-content-end">
                  <button translate pButton type="button" class="p-button-raised p-button-warning p-button-sm"
                    (click)="showDialog()">
                    <i class="fa fa-filter mr-1"></i>{{'vorPCA.filter'}}</button>
                  <button translate pButton type="button" class="p-button-raised p-button-secondary p-button-sm ml-1"
                    (click)="getAll()">
                    <i class="fas fa-search mr-1"></i>{{'vorPCA.buscarDados'}}
                  </button>
                  <button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm ml-1"
                    (click)="exportExcel()">
                    <i class="fa fa-download mr-1"></i>Export Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mr-2 ml-2 background">
        <p-table [columns]="selectedColumns" [value]="data" class="style" [paginator]="data?.length > 0 "
          [loading]="loading" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
          (sortFunction)="customSort($event)" [customSort]="true"
          currentPageReportTemplate="{{'vorPCA.mostrandoRegistros' | translate}}"
          styleClass="p-datatable-striped p-datatable-sm" [rowHover]="true" id="excel-table" [autoLayout]="false"
          [scrollable]="true" scrollDirection="horizontal" [first]="first" (firstChange)="first = $event">
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col *ngFor="let col of selectedColumns" [style.width]="col.width">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-container *ngFor="let col of columns">
                <th *ngIf="col.field == 'detalhe'" class="text-center">
                  {{col.header}}
                </th>
                <th *ngIf="col.field != 'detalhe'" [ngStyle]="{'width': col.width}" class="text-center"
                  [pSortableColumn]="col.field" [translate]="getTranslate(col.header)">
                  {{col.header}}
                  <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <ng-container *ngFor="let col of columns">
                <td *ngIf="col.field == 'detalhe'" style="padding: 2px;">
                  <button class="btn-ver" pTooltip="{{'rmpv.detalhado.verDetalhe' | translate}}"
                    (click)="visualizar(data)" style="cursor: pointer;">
                    <img src="assets/img/detail.png" />
                  </button>
                </td>
                <td *ngIf="col.field == 'tipoOs'" class="text-center">
                  <div [pTooltip]="data.tipoOsDescricao" [tooltipPosition]="col.tooltipPosition">
                    {{data[col.field]}}
                  </div>
                </td>
                <td *ngIf="col.field == 'motivoParada'" class="text-center">
                  <div [translate]="getTranslate(data[col.field])" [pTooltip]="data.detalheOsParada"
                    [tooltipPosition]="col.tooltipPosition">
                    {{data[col.field]}}
                  </div>
                </td>
                <td *ngIf="col.field == 'observacao'" class="text-center">
                  <div style="display: flex; justify-content: center;">
                    <button pButton pRipple type="button" icon="pi pi-file" class="p-button-rounded p-button-sm p-mr-1"
                      [ngClass]="getClasseObservacao(data)" pTooltip="Observação" *ngIf="col.field === 'observacao'"
                      (click)="abrirObservacao(data)">
                    </button>
                  </div>
                </td>
                <td
                  *ngIf="col.field != 'detalhe' && col.field != 'tipoOs' && col.field != 'motivoParada' && col.field != 'observacao'"
                  class="text-center">
                  {{col.type ? col.type.transform(data[col.field], col.arg1) : data[col.field]}}
                  <button *ngIf="col.field === 'edit'" pButton type="button"
                    class="p-button-raised p-button-info p-button-sm border-circle"
                    pTooltip="{{'vorPCA.detalhesOs' | translate}}" icon="fa fa-info" (click)="getId(rowIndex)">
                  </button>
                </td>
              </ng-container>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <div class="emptymessage mr-2 ml-2">
    <div *ngIf="data?.length === 0" class="text-center" translate>{{'vorPCA.grid'}}</div>
  </div>

  <!--Dialogs-->
  <ng-container>
    <p-dialog class="top-dialog" [(visible)]="display" [modal]="true" [draggable]="true" [resizable]="false"
      [style]="{'width':'650px'}">
      <ng-template pTemplate="header">
        <h5 translate class="modal-title">{{'rmpv.detalhado.filtros.definirFiltros'}}</h5>
      </ng-template>
      <ng-template pTemplate="body">

        <div class="container striped-rows">
          <div class="row ptb5">
            <div class="col col-4">
              Dealer
            </div>
            <div class="col col-8">
              <p-dropdown [options]="dealers" [(ngModel)]="filtros.dealers" optionLabel="descricao" optionValue="id"
                placeholder="{{'rmpv.relatorioAnaliseGeral.filtros.dealerPlaceHolder' | translate}}" [showClear]="true"
                [style]="{'width':'100%'}"></p-dropdown>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.detalhado.filtros.chassi'}}
            </div>
            <div class="col col-8">
              <input type="text" pInputText [ngClass]="'form-control form-control-sm'"
                placeholder="{{'rmpv.detalhado.filtros.chassiPlaceHolder' | translate}}" [(ngModel)]="filtros.chassi">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.detalhado.filtros.numeroOS'}}
            </div>
            <div class="col col-8">
              <input type="text" pInputText [ngClass]="'form-control form-control-sm'"
                placeholder="{{'rmpv.detalhado.filtros.numeroOSPlaceHolder' | translate}}" [(ngModel)]="filtros.numero">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'vorPCA.motivoParada'}}
            </div>
            <div class="col col-8">
              <p-multiSelect [options]="motivoParada" [(ngModel)]="filtros.motivo" optionLabel="descricao"
                optionValue="descricao" display="chip" [showToggleAll]="true"
                placeholder="{{'rmpv.relatorioAnaliseGeral.filtros.motivoPlaceHolder' | translate}}"
                [style]="{'width':'100%'}" appendTo="body"></p-multiSelect>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'vorPCA.modelo'}}
            </div>
            <div class="col col-8">
              <input type="text" pInputText [ngClass]="'form-control form-control-sm'"
                placeholder="{{'vorPCA.modeloPlaceholder'  | translate}}" [(ngModel)]="filtros.modelo">
            </div>
          </div>
          <div class="row ptb5">
            <div class="col col-4">
              Andamento
            </div>
            <div class="col col-8">
              <p-multiSelect [options]="andamentos" [(ngModel)]="filtros.andamento" optionLabel="descricao"
                optionValue="descricao" display="chip" [showToggleAll]="true" placeholder="Selecione o andamento"
                [style]="{'width':'100%'}" appendTo="body">
              </p-multiSelect>
            </div>
          </div>
<div class="row ptb5">
  <div class="col col-4">
    Dias Abertos
  </div>
  <div class="col col-8">
    <input type="number" pInputText [ngClass]="'form-control form-control-sm'"
      min="0" placeholder="Informe os dias abertos..."
      [ngModel]="filtros.dias"
      (ngModelChange)="filtros.dias = $event"
      (keypress)="bloquearNegativo($event)">
  </div>
</div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button type="button" class="btn btn-info mt-1 pull-right" (click)="getAll()">OK</button>
        <button type="button" class="btn btn-outline-secondary mt-1 pull-right mr-1" (click)="cleanFilter()"><i
            class="fa fa-trash" aria-hidden="true"></i></button>
      </ng-template>
    </p-dialog>
  </ng-container>

  <ng-container>
    <p-dialog class="top-dialog" [(visible)]="displayEdit" [modal]="true" [draggable]="true" [resizable]="false">
      <ng-template pTemplate="header">
        <h5 translate class="modal-title">{{'vorPCA.titleDialog'}}</h5>
      </ng-template>
      <ng-template pTemplate="body">
        <div class="container striped-rows">
          <div class="row ptb5">
            <div class="col col-8">
              <textarea pInputTextarea class="form-control form-control-sm"
                placeholder="{{'vorPCA.dialogPlaceholder' | translate}}" maxlength="20"
                [(ngModel)]="vorData.descricao"></textarea>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button type="button" class="btn btn-info mt-1 pull-right" (click)="edit()">OK</button>
      </ng-template>
    </p-dialog>
  </ng-container>

  <ng-container>
    <p-dialog header="Observação" [(visible)]="displayObservacao" [style]="{width: '50vw'}">
      <ng-template pTemplate="body">

        <div class="mb-2" style="display: flex; gap: 8px;">
          <button pButton type="button" label="Concluído" class="p-button-success p-button-sm"
            (click)="selecionarStatusObservacao('concluido')">
          </button>

          <button pButton type="button" label="Em análise" class="p-button-warning p-button-sm"
            (click)="selecionarStatusObservacao('em analise')">
          </button>
        </div>

        <textarea pInputTextarea [(ngModel)]="observacaoParada" rows="10" style="width: 100%; resize: vertical;">
    </textarea>

      </ng-template>

      <ng-template pTemplate="footer">
        <p-button label="Salvar" icon="pi pi-check" iconPos="left" (click)="salvar()">
        </p-button>
      </ng-template>
    </p-dialog>
  </ng-container>
</ng-container>

<div *ngIf="idOs" class="conteudo container-fluid">
  <div class="float-top-right">
    <div class="btn-group btn-group-toggle barra" data-toggle="buttons">
      <label translate class="btn btn-secondary" (click)="voltar()">
        <em class="fa fa-arrow-left"></em> {{'rmpv.detalhado.voltar'}}
      </label>
    </div>
  </div>
  <app-os [id]="idOs"></app-os>
</div>